import { render, staticRenderFns } from "./AddSeriesModal.vue?vue&type=template&id=28dee201&scoped=true&"
import script from "./AddSeriesModal.vue?vue&type=script&lang=js&"
export * from "./AddSeriesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSeriesModal.vue?vue&type=style&index=0&id=28dee201&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dee201",
  null
  
)

export default component.exports